module.exports = "/subscriptions/assets/8f8870915f56ab270fd8e311df182c24.jpg";